import React from 'react'
import icons from "../../icons";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import {loginSessionDetail } from '../../redux/reducers/LoginSessionSlice';
import Cookies from 'universal-cookie';
import { logoutFunc } from "../../services/authApiRoutes/APImethods";
import $ from "jquery";

export default function OrganizaitionSignin() {
    const { t } = useTranslation();
    const { register, handleSubmit ,formState: { errors }} = useForm({mode: "onBlur"});
    const validationRules = {
        email: { 
            required: `${t('email_validation.required')}`,
            pattern : {
                value : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                message : `${t('email_validation.format')}`,
            }
        }
      };
    const handleFormSubmit = (event) => {
        setErrorMessage('');
        event.preventDefault();
        logoutFunc().then(response => {
            if (response.data.success) {
                document.ssoLoginForm.submit();
            }
        });
    };

    const [errorMessage, setErrorMessage] = useState([]);
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');

    useEffect( ()=>{
        if( error && error !=''){
           if(error == 'different_user'){
                setErrorMessage('Logged in with different user.')
           }else if(error == 'unauthorized_user'){
                setErrorMessage('The user is not authorized to login through SSO.')
           }else{
                setErrorMessage('Some error occurred in login.')
           }
        }
    })

    useEffect(()=>{
      setTimeout(() => {
        $('#inputEmail').trigger('focus');
      }, 300);
    }, []);


  return (
    <div>
      <form name="ssoLoginForm" onSubmit={handleFormSubmit} action={process.env.REACT_APP_BACKEND_SERVER+"/sso/login"} method="post">

      {
      errorMessage !== ''
       ?
        <p className="error" aria-label="error alert" role="alert">
        {errorMessage}
        </p>
       : ''
       }
        <div className="input-group">
          <span className="input-group-text">
            <img src={icons.EMAIL_ICON} alt="Email Icon" />
          </span>
          <input
            type="email"
            id='inputEmail'
            className="form-control"
            placeholder={t('email')}
            aria-required="true"
            name="email"
            {...register('email', validationRules.email)}
          required/>
        </div>
       
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            name="checkbox"
            value=""
            id="customCheckbox"
          />
          <label className="form-check-label" htmlFor="customCheckbox">
          {t('remember_me')}
          </label>
        </div>
        <div className="form-button">
          <button type="submit" className="btn">
          {t('login')}
          </button>
        </div>
       
       
      </form>
    </div>
  )
}
